import { render } from "./DietChoice.vue?vue&type=template&id=676cf8d3"
import script from "./DietChoice.vue?vue&type=script&lang=js"
export * from "./DietChoice.vue?vue&type=script&lang=js"

import "./DietChoice.vue?vue&type=style&index=0&id=676cf8d3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__